<ng-container
  *ngTemplateOutlet="showMobileNav ? mobile : desktop"
></ng-container>

<ng-template #desktop>
  <header class="header" [style.height.px]="headerOffset">
    <div #stickyHeader [ngClass]="{ 'top-sticky-header': this.fixedHeader }">
      @if (headerCalloutVisible) {
        <app-header-callout></app-header-callout>
      }
      <nav class="nav" id="desktop-nav">
        <div class="container">
          <a class="logo" routerLink="/" id="desktop-logo-link">
            <img class="logo__svg" src="/assets/img/logos/perch_logo_svg.svg" />
          </a>

          <app-header-search [pageType]="currentPage"></app-header-search>

          <div class="nav__utility">
            <ul>
              @if (canSeeNotifications) {
                <li>
                  <a
                    class="btn btn-icon"
                    id="notifications-link"
                    placement="bottom"
                    routerLink="/notifications"
                  >
                    <i class="fal fa-envelope" aria-hidden="true"></i>
                    @if (unreadNotificationCount > 0) {
                      <span class="badge"></span>
                    }
                  </a>
                </li>
              }
              <li
                class="nav__utility__dropdown__trigger"
                (mouseenter)="dropdownMouseEnter($event)"
                (mouseleave)="dropdownMouseLeave($event)"
              >
                <app-user-menu></app-user-menu>
              </li>
              @if (canSeeFavorites) {
                <li class="nav__utility__dropdown__trigger">
                  <button
                    class="btn btn-icon"
                    id="favorites-btn"
                    title="Favorites"
                    (click)="navigateToFavorites($event)"
                  >
                    <i class="fal fa-heart"></i>
                  </button>
                </li>
              }
              @if (canOder) {
                <li
                  class="nav__utility__dropdown__trigger"
                  (mouseenter)="dropdownMouseEnter($event)"
                  (mouseleave)="dropdownMouseLeave($event)"
                >
                  <button
                    class="btn btn-icon shopping-cart"
                    id="shopping-cart-btn"
                    placement="bottom"
                  >
                    <i class="fal fa-shopping-cart" aria-hidden="true"></i>
                    @if (totalOrderItems) {
                      <span>{{ totalOrderItems }}</span>
                    }
                  </button>
                  <div
                    class="nav__utility__dropdown right-align orders-box uppercase font-6"
                  >
                    <div class="arrow"></div>
                    <div class="row">
                      @if (canSeeBuyingWindows) {
                        <div class="column col-6 border-end">
                          @if (
                            activeOrderWindow &&
                            orderService.activeBWOrder &&
                            orderService.activeBWOrder.item_count > 0
                          ) {
                            <div class="nav__main__dropdown__summary">
                              <h4>Buying Window</h4>
                              <p>
                                Order Summary
                                <span
                                  class="price font-1 fw-bold color--primary-blue"
                                >
                                  {{
                                    orderService.activeBWOrder.totalCost
                                      | currency
                                  }}</span
                                >
                              </p>
                              <p>
                                Items
                                <span
                                  class="font-1 fw-bold color--primary-blue"
                                >
                                  {{
                                    orderService.activeBWOrder.item_count
                                  }}</span
                                >
                              </p>
                              <button
                                (click)="navigateToActiveBWOrder()"
                                id="view-bw-order-btn"
                                class="btn btn-primary"
                              >
                                View Order
                              </button>
                            </div>
                          }
                          @if (
                            activeOrderWindow &&
                            (!orderService.activeBWOrder ||
                              orderService.activeBWOrder.item_count == 0)
                          ) {
                            <div class="nav__main__dropdown__summary">
                              <h4>Buying Window</h4>
                              <p>Your Order Summary is empty.</p>
                              <p class="flex-1-1">
                                You should probably fix that.
                              </p>
                              <button
                                (click)="navigateToAllBWPrograms()"
                                id="bw-programs-btn"
                                class="btn btn-outline-primary"
                              >
                                Programs
                              </button>
                            </div>
                          }
                          @if (!activeOrderWindow) {
                            <div class="nav__main__dropdown__summary">
                              <h4>Buying Window</h4>
                              <p>
                                There is no active Buying Window open at this
                                time.
                              </p>
                              @if (statistics?.ow_upcoming) {
                                <p class="flex-1-1">
                                  Please check back on
                                  {{
                                    statistics.ow_upcoming.start_at.format(
                                      'MMMM D, YYYY'
                                    )
                                  }}
                                </p>
                              }
                            </div>
                          }
                        </div>
                      }
                      <div
                        class="column"
                        [ngClass]="{
                          'col-6': canSeeBuyingWindows,
                          'col-12': !canSeeBuyingWindows,
                        }"
                      >
                        @if (
                          orderService.activeODOrder &&
                          orderService.activeODOrder.item_count > 0
                        ) {
                          <div class="nav__main__dropdown__summary border-none">
                            <h4>On Demand</h4>
                            <p>
                              Shopping Cart
                              <span
                                class="price font-1 fw-bold color--primary-blue"
                              >
                                {{
                                  orderService.activeODOrder.totalCost
                                    | currency
                                }}</span
                              >
                            </p>
                            <p>
                              Items
                              <span class="font-1 fw-bold color--primary-blue">
                                {{
                                  orderService.activeODOrder.item_count
                                }}</span
                              >
                            </p>
                            <button
                              (click)="navigateToActiveODOrder()"
                              id="checkout-od-order-btn"
                              class="btn btn-primary"
                            >
                              Checkout
                            </button>
                          </div>
                        } @else {
                          <div class="nav__main__dropdown__summary border-none">
                            <h4>On Demand</h4>
                            <p>Your Shopping Cart is empty</p>
                            <p class="flex-1-1">
                              You should probably fix that.
                            </p>
                            <button
                              id="od-inventory-btn"
                              (click)="onSelectModal('onDemand')"
                              class="btn btn-outline-primary"
                              routerLink="/on-demand/products"
                            >
                              Inventory
                            </button>
                          </div>
                        }
                      </div>
                    </div>
                    <a
                      class="link small mt-3 view-orders"
                      id="view-all-orders-link"
                      (click)="onSelectModal('buyingWindow')"
                      routerLink="/cart"
                    >
                      VIEW ALL ORDERS / CARTS
                    </a>
                  </div>
                </li>
              }
              <li class="nav__utility__dropdown__trigger">
                <button
                  class="btn btn-icon"
                  id="sustainability-btn"
                  title="Sustainability"
                  (click)="navigateToSustainabilityPage($event)"
                >
                  <i class="fal fa-leaf"></i>
                </button>
              </li>

              <li
                class="nav__utility__dropdown__trigger"
                (mouseenter)="dropdownMouseEnter($event)"
                (mouseleave)="dropdownMouseLeave($event)"
              >
                <button class="btn btn-icon" id="help-btn" placement="bottom">
                  <i class="fal fa-question" aria-hidden="true"></i>
                </button>
                <div
                  class="nav__utility__dropdown right-align row"
                  id="help-dropdown"
                >
                  <div class="arrow"></div>
                  <div class="column col-12">
                    <ul class="nav__utility__dropdown__links">
                      <li>
                        <a
                          class="link extra-small fw-normal"
                          id="contact-support-link"
                          href="mailto:HelpNest@hhglobal.com"
                        >
                          <i class="fal fa-envelope-open"></i>&nbsp;Contact
                          Support
                        </a>
                      </li>
                      <li>
                        <a
                          class="link extra-small fw-normal"
                          id="faq-link"
                          routerLink="/faq"
                          >Frequently Asked Questions</a
                        >
                      </li>
                      <li>
                        <a
                          class="link extra-small fw-normal"
                          id="perch-user-guide-link"
                          [href]="perchUserGuideUrl"
                          target="_blank"
                          >Perch User Guide</a
                        >
                      </li>
                      @if (canShowCustomRequest) {
                        <li>
                          <a
                            class="link extra-small fw-normal"
                            id="custom-request-user-guide-link"
                            [href]="customRequestUserGuideUrl"
                            target="_blank"
                            >Custom Request User Guide</a
                          >
                        </li>
                      }
                      <li><app-vendor-modal></app-vendor-modal></li>
                    </ul>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </nav>
      <a
        [ngClass]="{ 'is-active': mobileNavActive }"
        href="#main-menu-toggle"
        class="mobile__menu__backdrop"
        tabindex="-1"
        aria-hidden="true"
        hidden
      ></a>
      <!--            links -->
      <div class="links-container">
        <ul class="nav__main">
          @if (canSeeBuyingWindows) {
            <li
              id="nav-buying-window"
              class="nav__main__dropdown__trigger"
              [ngClass]="{ disabled: !activeOrderWindow }"
              [class.is-active]="buyingWindowMenuActive"
              role="link"
              (mouseenter)="showMenu(buyingWindowType)"
              (mouseleave)="hideMenu(buyingWindowType)"
            >
              <span class="nav__main__dropdown__title click font-4"
                >Buying Window</span
              >
              <app-header-navigation
                [type]="buyingWindowType"
                [visible]="buyingWindowMenuActive"
                (close)="hideMenu(buyingWindowType)"
              ></app-header-navigation>
            </li>
          }

          <li
            id="nav-on-demand"
            class="nav__main__dropdown__trigger"
            role="link"
            (mouseenter)="showMenu(onDemandType)"
            (mouseleave)="hideMenu(onDemandType)"
            [class.is-active]="ondemandMenuActive"
          >
            <span class="nav__main__dropdown__title click font-4"
              >On Demand</span
            >
            <app-header-navigation
              [type]="onDemandType"
              [visible]="ondemandMenuActive"
              (close)="hideMenu(onDemandType)"
            ></app-header-navigation>
          </li>

          @if (clearanceUrl) {
            <li
              id="nav-clearance"
              class="nav__main__dropdown__trigger"
              role="link"
              (click)="navigateToClearance()"
            >
              <span class="nav__main__dropdown__title click font-4"
                >Clearance</span
              >
            </li>
          }

          @if (canShowCustomRequest) {
            <li
              id="header-nav-custom-request"
              class="nav__main__dropdown__trigger"
              role="link"
              (click)="navigateToCustomRequest()"
            >
              <span class="nav__main__dropdown__title click font-4"
                >Custom Request</span
              >
            </li>
          }

          @if (truckGraphicsUrl) {
            <li
              id="nav-truck-graphics"
              class="nav__main__dropdown__trigger"
              role="link"
              (click)="navigateToTruckGraphics()"
            >
              <span class="nav__main__dropdown__title click font-4"
                >Truck Graphics</span
              >
            </li>
          }

          @if (repackUrl) {
            <li
              id="nav-repack"
              class="nav__main__dropdown__trigger"
              role="link"
              (click)="navigateToRepack()"
            >
              <span class="nav__main__dropdown__title click font-4"
                >Repack</span
              >
            </li>
          }

          @if (canSeeReports) {
            <li
              id="nav-reports"
              class="nav__main__dropdown__trigger"
              routerLink="/reports"
              role="link"
            >
              <span class="nav__main__dropdown__title click font-4"
                >Reports</span
              >
            </li>
          }
        </ul>
      </div>
    </div>
  </header>
</ng-template>

<ng-template #mobile>
  <header class="mobile" id="mobile-header">
    @if (headerCalloutVisible) {
      <app-header-callout></app-header-callout>
    }
    <div class="d-flex align-items-center">
      <a class="logo" routerLink="/" id="mobile-logo-link">
        <img class="logo__svg" src="/assets/img/logos/perch_logo_svg.svg" />
      </a>

      @if (!isMobile) {
        <div class="flex-1-1">
          <div class="mw-400px mx-auto">
            <app-header-search [pageType]="currentPage"></app-header-search>
          </div>
        </div>
      }
      @if (isMobile) {
        <div class="search--container">
          @if (showSearchButton) {
            <form class="app-search mobile" action="/search">
              <input
                type="submit"
                value="Search"
                id="mobile-search-submit"
                class="form-control"
                (click)="toggleGlobalSearch($event)"
              />
              <i class="far fa-search"></i>
            </form>
          }
        </div>
      }

      <nav>
        <button
          class="btn btn-icon with-border with-light-shadow ms-2"
          id="mobile-favorites-btn"
          title="Favorites"
          (click)="navigateToFavorites($event)"
        >
          <i class="far fa-heart"></i>
        </button>
        <button
          class="btn btn-icon with-border with-light-shadow mx-2"
          id="mobile-cart-btn"
          title="Shopping Cart"
          (click)="mobileCartMenuVisible = !mobileCartMenuVisible"
        >
          <i
            class="far"
            [ngClass]="{
              'fa-shopping-cart': !mobileCartMenuVisible,
              'fa-times': mobileCartMenuVisible,
            }"
          ></i>
        </button>
        <button
          class="btn btn-icon with-border with-light-shadow me-2"
          id="mobile-nav-menu-btn"
          title="Links"
          (click)="mobileNavigationMenuVisible = !mobileNavigationMenuVisible"
        >
          <i
            class="far"
            [ngClass]="{
              'fa-bars': !mobileNavigationMenuVisible,
              'fa-times': mobileNavigationMenuVisible,
            }"
          ></i>
        </button>
      </nav>
    </div>
    @if (showSearchInput) {
      <app-global-search
        [showBackdrop]="showSearchButton"
        (closed)="onSearchInputClosed()"
      ></app-global-search>
    }
  </header>
  <div class="position-relative">
    <app-mobile-cart-menu
      [visible]="mobileCartMenuVisible"
      (closed)="mobileCartMenuVisible = false"
    ></app-mobile-cart-menu>
    <app-mobile-navigation-menu
      [visible]="mobileNavigationMenuVisible"
      (onBWProductsClicked)="navigateToBWProducts()"
      (onBWProgramsClicked)="navigateToAllBWPrograms()"
      (onODProgramsClicked)="navigateToODPrograms()"
      (onODProductsClicked)="navigateToODProducts()"
      (closed)="mobileNavigationMenuVisible = false"
    ></app-mobile-navigation-menu>
  </div>
</ng-template>
